import { map } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Button, TextField } from '@mui/material';
import { RemoveCircle } from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';

import moment from 'moment';
import styles from './Locations.module.css';

const useStyles = makeStyles()((theme) => ({
  remove: {
    fill: theme.palette.text.primary,
    '&:hover': {
      fill: theme.palette.text.dark,
      cursor: 'pointer',
    },
  },
}));

const formatMinutes = (minutes) =>
  moment().startOf('day').add(minutes, 'minutes').format('HH:mm');

const getMinutesFromMidnight = (hours, minutes) =>
  moment()
    .startOf('day')
    .add(hours, 'hours')
    .add(minutes, 'minutes')
    .diff(moment().startOf('day'), 'minutes');

export default function LocationHours(props) {
  const { classes } = useStyles();
  const { hours, setHours } = props;

  function setTime(e, index) {
    const {
      target: { value: time, name },
    } = e;
    const [hrs, mins] = time.split(':');
    const minutes = getMinutesFromMidnight(hrs, mins);
    const hour = hours[index];
    hour[name] = minutes;

    setHours(hours);
  }

  const addHour = () => {
    const hrs = hours.concat([{ start: 0, end: 0 }]);
    setHours(hrs);
  };

  function removeHour(index) {
    const hrs = hours.filter((_, i) => i !== index);
    setHours(hrs);
  }

  return (
    <div className={styles.locationHours}>
      <div className={styles.locationHoursHeader}>
        <h4>Hours:</h4>
        <Button
          onClick={addHour}
          color="primary"
          size="small"
          variant="outlined"
        >
          Add New Time Range
        </Button>
      </div>
      <div className={styles.locationHoursBody}>
        {map(hours, (hr, i) => (
          <div className={styles.locationHour} key={hr.id || i}>
            <TextField
              variant="standard"
              label="Start Time"
              type="time"
              name="start"
              error={hr.end && hr.start ? hr.end < hr.start : false}
              value={hr.start ? formatMinutes(hr.start) : '00:00'}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 1800 }}
              onChange={(e) => setTime(e, i)}
            />

            <TextField
              variant="standard"
              label="End Time"
              type="time"
              name="end"
              error={hr.end && hr.start ? hr.end < hr.start : false}
              value={hr.end ? formatMinutes(hr.end) : '00:00'}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              inputProps={{ step: 1800 }}
              onChange={(e) => setTime(e, i)}
            />

            <RemoveCircle
              className={classes.remove}
              onClick={() => removeHour(i)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

LocationHours.propTypes = {
  hours: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setHours: PropTypes.func.isRequired,
};
